import "../../components/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../components/Navbar";
import Select from "react-select";
import { loading, tokens, select_style, success, toFixed, GET, PUT, DELETE, format_date, alert, getStorage } from "../../components/CustomComponent.js";
import React, { Component } from "react";
import Swal from "sweetalert2";
import Pagination from "@mui/material/Pagination";
import { Modal } from "react-bootstrap";

const r_det = getStorage("role_detail")?.find(i => i.name === "record-water-usage")?.role || [];
const view_r = r_det[0] === 1, update_r = r_det[2] === 1;

export default class WaterUsageInfo extends Component {
  constructor(props) {
    super(props);
    let d = new Date();
    this.state = {
      page: 1, filter_address_number: null, modal_update: false, search_room: null, new_full_name: null,
      data: null, data_address: [], data_room: null, data_fullname: [],
      month_current: d, month_last: new Date(d.getFullYear(), d.getMonth() - 1, d.getDate()),
    };
  }

  async componentDidMount() {
    if (!view_r) return;
    loading(true);
    await Promise.all([this.GetAll(), this.GetAddressAll()]);
    loading(false);
  }

  pid = () => getStorage("project_id");

  GetAddressAll = async () => {
    let r = await GET(tokens, `v1/TH/customer-manage/filter-search/page/0/${this.pid()}`, { data_search: "", transfer_date: "", status_transfer: "" });
    if (r?.status) this.setState({ data_address: r.data.data.map(i => ({ value: i.address_number, label: `อาคาร ${i.building} ห้อง ${i.address_number}` })) });
  };

  GetAll = async () => {
    loading(true);
    let r = await GET(tokens, `v1/TH/record-water/filter-search/page/${this.state.page}/${this.pid()}`, { address_number: this.state.filter_address_number?.value || "" });
    if (r?.status) this.setState({ data: r.data });
    loading(false);
  };

  GetRoomAll = async () => {
    loading(true);
    let r = await GET(tokens, `v1/TH/record-water/filter-search/page/0/${this.pid()}`, { address_number: this.state.search_room?.value || "" });
    if (r?.status) this.setState({ data_room: { ...r.data, data: r.data.data?.filter(e => e.status_pay !== 3) } });
    loading(false);
  };

  GetFullnameById = async () => {
    let r = await GET(tokens, `v1/TH/customer-manage/by-address/${this.pid()}`, { address_number: this.state.search_room?.value || "" });
    if (r?.status) this.setState({ data_fullname: r.data.data.map(e => ({ label: e.full_name, value: e.full_name, ref_customer_id: e.ref_customer_id })) });
  };

  UpdateFullname = async () => {
    const { new_full_name, data_room, data_fullname } = this.state;
    if (!new_full_name) return alert("warning", "แจ้งเตือน", "กรุณาเลือกชื่อ-นามสกุลที่ต้องการเปลี่ยน");
    loading(true);
    
    const ref_customer_id = data_fullname?.find(e => e.value === new_full_name.value)?.ref_customer_id || null;
    await Promise.all(data_room.data.filter(i => i.selected).map(i => 
      PUT(tokens, "v1/TH/record-water/update", { record_water_id: i.record_water_id, address_number: i.address_number || "", full_name: new_full_name.value || "", ref_customer_id })
    ));

    success();
    loading(false);
    this.setState({ modal_update: false }, this.GetAll);
  };

  Delete = async (id) => {
    loading(true);
    let r = await DELETE(tokens, `v1/TH/record-water/delete/${id}`, null);
    if (r?.status) {
      this.setState({ page: 1, filter_address_number: null });
      success();
      this.GetAll();
    }
    loading(false);
  };

  toggleAllRoom = (e) => this.setState(s => ({ data_room: { ...s.data_room, data: s.data_room.data.map(i => ({ ...i, selected: e.target.checked })) } }));
  toggleRoomItem = (idx, chk) => this.setState(s => {
    let d = [...s.data_room.data];
    d[idx].selected = chk;
    return { data_room: { ...s.data_room, data: d } };
  });

  canDelete = (i) => !["s_add_debt", "s_cable_cost", "s_common_expenses", "s_equipment_maintenance_fee", "s_fire_cost", "s_late_payment", "s_meter_connect_cost", "s_other_income", "s_reduce_debt", "s_waste_cost", "s_water_bill"].some(k => i[k]);

  // ตัวช่วยลดการเขียน UI ซ้ำ
  renderRowData = (item, isModal) => {
    const fmt = (val) => val ? toFixed(val) : "0.00";
    return (
      <>
        <td className="text-center">{item.address_number || "-"}</td>
        {isModal && <td className="text-center">{item.full_name || "-"}</td>}
        <td className="text-left">{item.datetime_create ? format_date(item.datetime_create) : "0"}</td>
        <td className="text-right">{item.current_gauge_number ? Number(item.current_gauge_number) : "0"}</td>
        <td className="text-right">{item.last_gauge_number ? Number(item.last_gauge_number) : "0"}</td>
        <td className="text-right">{fmt(item.unit_used)}</td><td className="text-right">{fmt(item.water_bill)}</td>
        <td className="text-right">{fmt(item.equipment_maintenance_fee)}</td><td className="text-right">{fmt(item.common_expenses)}</td>
        <td className="text-right">{fmt((item.other_income || 0) + (item.cable_cost || 0))}</td><td className="text-right">{fmt(item.total_amount)}</td>
      </>
    );
  };

  render() {
    const s = this.state;
    const hdrs = ["บ้านเลขที่", "วันที่บันทึก", `เลขมาตรเดือน${format_date(s.month_current, "MMM")}`, `เลขมาตรเดือน${format_date(s.month_last, "MMM")}`, "จำนวนหน่วยที่ใช้", "ค่าน้ำประปา", "ค่ารักษาอุปกรณ์น้ำ", "ค่าส่วนกลาง", "รายการอื่นๆ", "รวมเป็นเงิน"];

    return (
      <div className="w-100 min-vh-100 fade-in">
        {s.loading && <div className="spinner-container"><div className="loading-spinner"></div></div>}
        <Navbar page1="หน้าหลัก" page2="ข้อมูลการใช้น้ำ" />
        
        <div className="body">
          <div className="p-3">
            <div className="card border-0 p-3">
              <div className="d-flex row mx-0 align-items-center justify-content-between">
                <h4 className="mb-3"><b>ข้อมูลการใช้น้ำประจำเดือน{format_date(new Date(), "MMMM")} พ.ศ. {format_date(new Date(), "YYYY")}</b></h4>
                <div className="d-flex row mx-0">
                  <button className="btn btn-primary px-4 mx-1 mb-3" onClick={() => this.setState({ modal_update: true, search_room: null, data_fullname: null, new_full_name: null, data_room: null })}>แก้ไขรายชื่อบิลตามบ้านเลขที่</button>
                  <button className="btn btn-outline-primary px-4 mx-1 mb-3" onClick={() => window.location.href = "/record-water-usage"}>ย้อนกลับ</button>
                </div>
              </div>

              {view_r && (
                <div className="d-flex row mx-0 align-items-center justify-content-between">
                  <div className="d-flex row mx-0">
                    <Select className="form-control bg-contain border-0 select-search wpx-200 mb-3 mx-1" styles={select_style} options={s.data_address} onChange={(e) => this.setState({ filter_address_number: e })} value={s.filter_address_number} />
                    <button className="btn btn-primary px-3 mb-3 mx-1" onClick={() => this.setState({ page: 1 }, this.GetAll)}>ค้นหา</button>
                    <button className="btn btn-outline-primary px-3 mb-3 mx-1" onClick={() => this.setState({ filter_address_number: null, page: 1 }, this.GetAll)}>รีเซ็ท</button>
                  </div>
                </div>
              )}

              <div className="table-responsive">
                <table className="table table-borderless table-striped">
                  <thead>
                    <tr className="bg-dark-blue text-white">
                      {hdrs.map((h, i) => <th key={i} className={i === 1 ? "text-left" : "text-center"}>{h}</th>)}
                      {update_r && <th className="text-center">จัดการ</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {!s.data?.data?.length ? <tr><td colSpan={11} className="text-center">ไม่มีข้อมูล</td></tr> : s.data.data.map((item, index) => (
                      <tr key={index}>
                        {this.renderRowData(item, false)}
                        {update_r && (
                          <td className="text-center">
                            <div className="d-flex justify-content-center">
                              <label className="wpx-24 hpx-24 bg-primary-light rounded-1 d-flex align-items-center justify-content-center mr-2 icon text-primary pointer" onClick={() => window.location.href = "/record-water-usage?id=" + item.record_water_id}>{"\uf304"}</label>
                              {this.canDelete(item) && (
                                <label className="wpx-24 hpx-24 bg-danger-light rounded-1 d-flex align-items-center justify-content-center mr-2 icon text-danger pointer" onClick={() => Swal.fire({ icon: "warning", title: "ยืนยันการลบข้อมูล", text: "คุณต้องการลบข้อมูลนี้ใช่หรือไม่", showCancelButton: true, cancelButtonColor: "#d33", confirmButtonText: "ลบข้อมูล", cancelButtonText: "ยกเลิก" }).then((res) => { if (res.isConfirmed) this.Delete(item.record_water_id); })}>{"\uf1f8"}</label>
                              )}
                            </div>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              
              {s.data?.data?.length > 0 && (
                <div className="d-flex justify-content-between row mx-0 w-100 px-3">
                  <div><label>แสดง {s.data.end_index} รายการ จาก {s.data.count} รายการ</label></div>
                  <Pagination count={s.data.page_number} page={s.page} color="primary" showFirstButton showLastButton onChange={(e, value) => this.setState({ page: value }, this.GetAll)} />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Modal Update Fullname */}
        <Modal show={s.modal_update} onHide={() => this.setState({ modal_update: false })} size="xl">
          <Modal.Header><Modal.Title><b>แก้ไขรายชื่อบิลตามบ้านเลขที่</b></Modal.Title></Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-12 col-md-6 col-lg-4 mb-2">
                <label>บ้านเลขที่</label>
                <Select className="form-control bg-contain border-0 select-search w-100 mb-3 mx-1" styles={select_style} options={s.data_address || []} value={s.search_room} onChange={(e) => this.setState({ search_room: e }, () => { this.GetRoomAll(); this.GetFullnameById(); })} />
              </div>
              <div className="col-12 col-md-6 col-lg-4 mb-2">
                <label>ชื่อ-นามสกุลที่ต้องการเปลี่ยน</label>
                <Select className="form-control bg-contain border-0 w-100 select-search" styles={select_style} options={s.data_fullname || []} value={s.new_full_name} onChange={(e) => this.setState({ new_full_name: e })} />
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-borderless table-striped">
                <thead>
                  <tr className="bg-dark-blue text-white">
                    <th className="text-center"><input type="checkbox" onChange={this.toggleAllRoom} checked={s.data_room?.data?.length > 0 && s.data_room.data.every(item => item.selected)} /></th>
                    {hdrs.map((h, i) => i === 1 ? (<React.Fragment key={i}><th className="text-center">ชื่อ-นามสกุล</th><th className="text-left">{h}</th></React.Fragment>) : <th key={i} className="text-center">{h}</th>)}
                  </tr>
                </thead>
                <tbody>
                  {!s.data_room?.data?.length ? <tr><td colSpan={12} className="text-center">ไม่มีข้อมูล</td></tr> : s.data_room.data.map((item, index) => (
                    <tr key={index}>
                      <td className="text-center"><input type="checkbox" checked={item.selected || false} onChange={(e) => this.toggleRoomItem(index, e.target.checked)} /></td>
                      {this.renderRowData(item, true)}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="w-100 d-flex mt-3">
              <div className="w-50 p-1"><button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_update: false })}>ยกเลิก</button></div>
              <div className="w-50 p-1"><button className="btn btn-primary w-100" onClick={this.UpdateFullname}>บันทึก</button></div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}